/* ============================================================
   MUSE — theme core (Shopify)
   ------------------------------------------------------------
   Ported from the Claude Design prototype (muse-core.js), with
   the localStorage cart replaced by the Shopify Cart AJAX API.
   Keeps: mega-menu drawer, cart drawer, toast, reveal-on-scroll,
   sticky/overlay header, product-card hover, quick-add, favorites.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.MUSE_CONFIG || {};
  var routes = cfg.routes || {};
  var strings = cfg.strings || {};
  var moneyFormat = cfg.moneyFormat || '{{amount}} ₽';

  /* ---------------- money (classic Shopify formatMoney) ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || moneyFormat;
    function defaultTo(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' ', ''); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ''); break;
      default: value = defaultTo(cents, 2, ' ', '');
    }
    return fmt.replace(placeholderRegex, value);
  }

  var esc = function (s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  /* ---------------- drawers / menu ---------------- */
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var openDrawer = function () { var o = $('#drawerOverlay'); if (o) o.classList.add('open'); };
  var closeDrawer = function () { var o = $('#drawerOverlay'); if (o) o.classList.remove('open'); };
  var openMenu = function () { var o = $('#menuOverlay'); if (o) o.classList.add('open'); };
  var closeMenu = function () { var o = $('#menuOverlay'); if (o) o.classList.remove('open'); };
  var openSearch = function () {
    var o = $('#searchOverlay'); if (!o) return;
    o.classList.add('open');
    var inp = o.querySelector('[data-search-input]');
    if (inp) setTimeout(function () { inp.focus(); }, 80);
  };
  var closeSearch = function () { var o = $('#searchOverlay'); if (o) o.classList.remove('open'); };
  var searchScroll = function (dir) {
    var row = $('#SearchRow'); if (!row) return;
    var card = row.querySelector('.sd-card');
    var step = card ? card.getBoundingClientRect().width + 16 : row.clientWidth * 0.5;
    row.scrollBy({ left: dir * step, behavior: 'smooth' });
  };
  var closeContactFab = function () {
    var f = $('.contact-fab.open'); if (!f) return;
    f.classList.remove('open');
    var b = f.querySelector('[data-contact-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
  };

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  /* ---------------- cart toast (top-right, with thumbnail) ---------------- */
  var cartToastTimer;
  function hideCartToast() { var t = $('#cartToast'); if (t) t.classList.remove('show'); }
  function cartToast(item) {
    if (!item) { toast(strings.added || 'Добавлено в корзину'); return; }
    var t = $('#cartToast');
    if (!t) { t = document.createElement('div'); t.id = 'cartToast'; t.className = 'cart-toast'; document.body.appendChild(t); }
    var url = item.url || routes.cart_url;
    var imgUrl = item.image ? String(item.image).replace(/(\.[^.\/]+)(\?.*)?$/, '_160x$1$2') : '';
    var title = esc(item.product_title || item.title || '');
    var thumb = imgUrl
      ? '<a class="ctt-thumb" href="' + url + '"><img src="' + imgUrl + '" alt=""></a>'
      : '<a class="ctt-thumb ph ph--shell" href="' + url + '" aria-hidden="true"></a>';
    t.innerHTML =
      thumb +
      '<div class="ctt-body">' +
        '<div class="ctt-label">' + (strings.added || 'Добавлено в корзину') + '</div>' +
        '<div class="ctt-title">' + title + '</div>' +
      '</div>' +
      '<a class="ctt-go" href="' + routes.cart_url + '" data-open-cart>' + (strings.goToCart || 'Перейти') + '</a>' +
      '<button class="ctt-close" data-close-carttoast aria-label="Закрыть">&times;</button>';
    t.classList.add('show');
    clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () { t.classList.remove('show'); }, 4500);
  }

  /* ---------------- favorites toast (top-right, with thumbnail) ---------------- */
  var favToastTimer;
  function hideFavToast() { var t = $('#favToast'); if (t) t.classList.remove('show'); }
  function favToast(el) {
    var t = $('#favToast');
    if (!t) { t = document.createElement('div'); t.id = 'favToast'; t.className = 'cart-toast'; document.body.appendChild(t); }
    var card = el && el.closest ? el.closest('.card') : null;
    var imgEl = card ? card.querySelector('.card-media img') : null;
    var imgUrl = imgEl ? (imgEl.currentSrc || imgEl.getAttribute('src') || '') : '';
    var titleEl = card ? card.querySelector('.card-title') : null;
    var title = esc(titleEl ? titleEl.textContent.trim() : (imgEl ? imgEl.alt : ''));
    var linkEl = card ? card.querySelector('a.card-media-link, a.card-body') : null;
    var favUrl = routes.favorites_url || '/pages/favorites';
    var prodUrl = linkEl ? linkEl.getAttribute('href') : favUrl;
    var thumb = imgUrl
      ? '<a class="ctt-thumb" href="' + prodUrl + '"><img src="' + imgUrl + '" alt=""></a>'
      : '<a class="ctt-thumb ph ph--shell" href="' + prodUrl + '" aria-hidden="true"></a>';
    t.innerHTML =
      thumb +
      '<div class="ctt-body">' +
        '<div class="ctt-label">' + (strings.favAddedToast || 'Добавлено в избранное') + '</div>' +
        '<div class="ctt-title">' + title + '</div>' +
      '</div>' +
      '<a class="ctt-go" href="' + favUrl + '">' + (strings.goToCart || 'Перейти') + '</a>' +
      '<button class="ctt-close" data-close-favtoast aria-label="Закрыть">&times;</button>';
    t.classList.add('show');
    clearTimeout(favToastTimer);
    favToastTimer = setTimeout(function () { t.classList.remove('show'); }, 4500);
  }

  /* show an inline "added / go to cart" confirmation on the product card */
  function showCardAdded(el) {
    if (!el) return;
    var media = el.closest('.card-media');
    if (!media) return;
    var quick = media.querySelector('.card-quick');
    if (!quick || quick.dataset.added) return;
    var card = el.closest('.card');
    quick.dataset.orig = quick.innerHTML;
    quick.dataset.added = '1';
    quick.classList.add('is-added');
    quick.innerHTML =
      '<a class="card-added" href="' + routes.cart_url + '" data-open-cart>' +
        '<span class="ca-label">' + (strings.added || 'Добавлено в корзину') + '</span>' +
        '<span class="ca-go">' + (strings.goToCart || 'Перейти') + ' &rarr;</span>' +
      '</a>';
    setTimeout(function () {
      if (!quick.dataset.added) return;
      quick.classList.remove('is-added');
      quick.innerHTML = quick.dataset.orig || '';
      delete quick.dataset.added; delete quick.dataset.orig;
      if (card) card.classList.remove('quick-open');
    }, 4000);
  }

  /* ---------------- CART (Shopify AJAX) ---------------- */
  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(idOrForm, qty, sourceEl) {
    var body;
    if (idOrForm instanceof HTMLFormElement) {
      body = new FormData(idOrForm);
    } else {
      body = { items: [{ id: idOrForm, quantity: qty || 1 }] };
    }
    var opts;
    if (body instanceof FormData) {
      opts = { method: 'POST', headers: { 'Accept': 'application/json' }, body: body };
    } else {
      opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) };
    }
    return fetch(routes.cart_add_url + '.js', opts)
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data && res.data.description ? res.data.description : (strings.soldOut || 'Недоступно')); return null; }
        return refreshCart().then(function () {
          // не открываем корзину сразу — показываем подтверждение (как у конкурента):
          // тост справа-сверху + инлайн-плашку на карточке; корзина откроется по «Перейти»
          var added = res.data && res.data.items ? res.data.items[0] : res.data;
          cartToast(added);
          showCardAdded(sourceEl);
          return res.data;
        });
      })
      .catch(function () { toast(strings.error || 'Ошибка'); });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function refreshCart() { return getCart().then(function (cart) { renderCart(cart); return cart; }); }

  function updateCounts(cart) {
    var n = cart ? cart.item_count : 0;
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; e.classList.toggle('is-zero', n === 0); });
    var f = readFav();
    $$('[data-fav-count]').forEach(function (e) { e.textContent = f.length; e.classList.toggle('is-zero', f.length === 0); });
  }

  function cartRowHTML(item) {
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(esc(item.variant_title));
    var img = item.image
      ? '<a href="' + item.url + '" class="thumb"><img src="' + item.image.replace(/(\.[^.\/]+)(\?.*)?$/, '_160x$1$2') + '" alt="" style="width:100%;height:100%;object-fit:cover"></a>'
      : '<a href="' + item.url + '" class="thumb ph ph--shell"></a>';
    return '<div class="cart-row" data-key="' + item.key + '">' +
      img +
      '<div>' +
        '<div class="ct-title">' + esc(item.product_title) + '</div>' +
        (meta.length ? '<div class="ct-mat">' + meta.join(' · ') + '</div>' : '') +
        '<div class="qty">' +
          '<button data-line-minus aria-label="−">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button data-line-plus aria-label="+">+</button>' +
        '</div>' +
      '</div>' +
      '<div style="text-align:right; display:flex; flex-direction:column; align-items:flex-end; justify-content:space-between;">' +
        '<div class="ct-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button class="ct-remove" data-line-remove>' + (strings.remove || 'Убрать') + '</button>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    updateCounts(cart);
    var body = $('#drawerBody'); var foot = $('#drawerFoot');
    if (!body) return;
    if (!cart || !cart.items || !cart.items.length) {
      body.innerHTML = '<div class="drawer-empty"><span class="serif">' + (strings.cartEmpty || 'Корзина пуста') + '</span>' +
        (strings.cartEmptyHint || 'Добавьте украшение, которое говорит «это — про тебя».') + '</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(cartRowHTML).join('');
    if (foot) {
      foot.style.display = 'block';
      var threshold = cfg.freeShippingFrom || 0;
      var note = '';
      if (threshold > 0) {
        note = (strings.freeShipNote || 'Бесплатная доставка по России при заказе от {amount}')
          .replace('{amount}', formatMoney(threshold));
      }
      foot.innerHTML =
        '<div class="row"><span class="t">' + (strings.subtotal || 'Итого') + '</span><span class="v">' + formatMoney(cart.total_price) + '</span></div>' +
        '<a class="btn btn--wide" href="' + routes.cart_url + '">' + (strings.checkout || 'Оформить заказ') + '</a>' +
        (note ? '<div class="note">' + note + '</div>' : '');
    }
  }

  /* ---------------- FAVORITES (localStorage wishlist) ---------------- */
  var LS_FAV = 'muse_fav_v1';
  function readFav() { try { return JSON.parse(localStorage.getItem(LS_FAV)) || []; } catch (e) { return []; } }
  function saveFav(list) { localStorage.setItem(LS_FAV, JSON.stringify(list)); }
  function isFav(handle) { return readFav().indexOf(handle) >= 0; }
  function toggleFav(handle, el) {
    var list = readFav(); var i = list.indexOf(handle);
    if (i >= 0) { list.splice(i, 1); } else { list.push(handle); favToast(el); }
    saveFav(list); syncFav(); updateCounts();
    document.dispatchEvent(new CustomEvent('muse:fav', { detail: { favorites: list } }));
  }
  function syncFav() {
    $$('[data-fav]').forEach(function (b) { b.classList.toggle('active', isFav(b.getAttribute('data-fav'))); });
  }

  /* ---------------- header overlay (transparent over hero) ---------------- */
  function initHeader() {
    var h = $('.site-header');
    if (!h || !h.classList.contains('is-overlay')) return;
    var ann = $('.announce');
    var annH = ann ? ann.offsetHeight : 0;
    var onScroll = function () {
      // фикс-шапка опускается из-под сервисной строки к самому верху,
      // пока строка уезжает; дальше остаётся приклеенной (top:0)
      h.style.top = Math.max(0, annH - window.scrollY) + 'px';
      if (window.scrollY > window.innerHeight * 0.72) h.classList.remove('is-overlay');
      else h.classList.add('is-overlay');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- reveal on scroll ---------------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- delegated events ---------------- */
  function initEvents() {
    document.addEventListener('click', function (e) {
      // mobile: tapping outside an open quick-add closes it
      if (!e.target.closest('.card-quick,[data-quick-toggle]')) {
        $$('.card.quick-open').forEach(function (c) { c.classList.remove('quick-open'); });
      }
      // tapping outside the contact button closes its expanded channels
      if (!e.target.closest('.contact-fab')) { closeContactFab(); }
      var t = e.target.closest('[data-fav],[data-add],[data-quick-toggle],[data-contact-toggle],[data-open-cart],[data-close-cart],[data-close-carttoast],[data-close-favtoast],[data-open-menu],[data-close-menu],[data-open-search],[data-close-search],[data-search-prev],[data-search-next],[data-line-minus],[data-line-plus],[data-line-remove]');
      if (!t) return;
      if (t.hasAttribute('data-contact-toggle')) {
        e.preventDefault();
        var fab = t.closest('.contact-fab'); if (!fab) return;
        var open = fab.classList.toggle('open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      if (t.hasAttribute('data-fav')) { e.preventDefault(); toggleFav(t.getAttribute('data-fav'), t); }
      else if (t.hasAttribute('data-quick-toggle')) {
        e.preventDefault();
        var qc = t.closest('.card'); if (!qc) return;
        var wasOpen = qc.classList.contains('quick-open');
        $$('.card.quick-open').forEach(function (c) { if (c !== qc) c.classList.remove('quick-open'); });
        qc.classList.toggle('quick-open', !wasOpen);
      }
      else if (t.hasAttribute('data-add')) { e.preventDefault(); addToCart(t.getAttribute('data-add'), 1, t); }
      else if (t.hasAttribute('data-open-cart')) { e.preventDefault(); hideCartToast(); openDrawer(); refreshCart(); }
      else if (t.hasAttribute('data-close-carttoast')) { e.preventDefault(); hideCartToast(); }
      else if (t.hasAttribute('data-close-favtoast')) { e.preventDefault(); hideFavToast(); }
      else if (t.hasAttribute('data-close-cart')) { closeDrawer(); }
      else if (t.hasAttribute('data-open-menu')) { e.preventDefault(); openMenu(); }
      else if (t.hasAttribute('data-close-menu')) { closeMenu(); }
      else if (t.hasAttribute('data-open-search')) { e.preventDefault(); openSearch(); }
      else if (t.hasAttribute('data-close-search')) { closeSearch(); }
      else if (t.hasAttribute('data-search-prev')) { e.preventDefault(); searchScroll(-1); }
      else if (t.hasAttribute('data-search-next')) { e.preventDefault(); searchScroll(1); }
      else if (t.hasAttribute('data-line-minus') || t.hasAttribute('data-line-plus') || t.hasAttribute('data-line-remove')) {
        var row = t.closest('[data-key]'); if (!row) return;
        var key = row.getAttribute('data-key');
        var span = row.querySelector('.qty span');
        var cur = span ? parseInt(span.textContent, 10) || 0 : 0;
        var next = t.hasAttribute('data-line-remove') ? 0 : (t.hasAttribute('data-line-plus') ? cur + 1 : cur - 1);
        changeLine(key, next < 0 ? 0 : next);
      }
    });
    var d = $('#drawerOverlay'); if (d) d.addEventListener('click', function (e) { if (e.target.id === 'drawerOverlay') closeDrawer(); });
    var m = $('#menuOverlay'); if (m) m.addEventListener('click', function (e) { if (e.target.id === 'menuOverlay') closeMenu(); });
    var s = $('#searchOverlay'); if (s) s.addEventListener('click', function (e) { if (e.target.id === 'searchOverlay') closeSearch(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeMenu(); closeSearch(); closeContactFab(); } });

    // product / quick-add forms posted via AJAX
    $$('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form); });
    });
  }

  function init() {
    initHeader(); initReveal(); initEvents(); syncFav();
    refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.MUSE = {
    formatMoney: formatMoney, addToCart: addToCart, refreshCart: refreshCart,
    openDrawer: openDrawer, closeDrawer: closeDrawer, openMenu: openMenu, closeMenu: closeMenu,
    toggleFav: toggleFav, isFav: isFav, readFav: readFav, toast: toast,
  };
})();
